import React, { useEffect, useState } from "react";
import { Form, Nav, Navbar, NavDropdown, Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import styled, { withTheme } from "styled-components";
import logo from "../../../assets/logo.png";
import { modalType } from "../../../modules/constants";
import {
  mapDispatchToPropsLayout,
  mapStateToPropsLayout,
} from "../../../modules/layout";
import {
  getUserDefaultRoute,
  mapDispatchToPropsLogin,
  mapStateToPropsLogin,
  decrypt,
} from "../../../modules/login";
import PrimaryButton from "../../ui-library/Buttons/PrimaryButton/PrimaryButton";
import UserImage from "./UserImage/UserImage";
import UserName from "./UserName/UserName";
import { history } from "../../../modules/history.js";
import ReactFlagsSelect from "react-flags-select";
import { getPublicLocale, refreshAppLanguage } from "../../../i18n/helpers.js";
import { publicLanguage, sessionLanguage } from "../../../config.js";
import Highlighter from "../Highlighter/Highlighter";
import {
  Overlay,
  useOverlay,
} from "../SystemInfoOverlay/SystemInfoOverlay.jsx";

const StyledNavbar = styled(Navbar)`
  background-color: ${(props) => props?.theme?.white};
  color: ${(props) => props?.theme?.fg};
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease-in-out;
  &:hover {
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  }
  .navbar-brand {
    font-size: 1.5rem;
    font-weight: 700;
    margin-left: 50px;
    transition: all 0.3s ease;
  }
  .navbar-brand {
    margin-left: 50px;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }
  .navbar-brand-landing {
    font-size: 1.5rem;
    font-weight: 700;
    display: inline-block;
  }
  .navbar-light .navbar-nav .nav-link {
    color: ${(props) => props?.theme?.gray} !important;
  }

  .navbar-nav .active > .nav-link,
  .navbar-nav .nav-link.active,
  .navbar-nav .nav-link.show,
  .navbar-nav .show > .nav-link {
    color: ${(props) => props?.theme?.darkPurple} !important;
  }
  .navbar-nav .nav-link:focus,
  .navbar-nav .nav-link:hover {
    color: ${(props) => props?.theme?.darkPurple} !important;
  }

  .navbar-nav .username-dropdown a {
    display: flex;
    align-items: center;
  }
  .navbar-nav .user-name {
    display: inline-block;
    text-align: center;
    white-space: pre-wrap;
    height: 24px;
    overflow: hidden;
    word-wrap: break-word;
    text-overflow: ellipsis;
  }
  .navbar-nav .right-actions {
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: center;
  }

  .navbar-nav .right-actions .language-select {
    padding-bottom: 0;
  }

  .navbar-nav .right-actions .language-select button {
    font-weight: 400;
    font-size: 0.875rem !important;
    line-height: 1.5;
    padding-top: 0.188rem;
    padding-bottom: 0.188rem;
    border-radius: 0.4rem;
  }

  .navbar-nav .right-actions .language-select button span {
    margin: 1px 0;
  }

  .navbar-nav .right-actions .language-select ul {
    min-width: 250px;
    max-height: none;
    font-weight: 400;
    font-size: 0.875rem !important;
  }

  .navbar-nav .dropdown-menu {
    right: 0;
    left: auto !important;
  }
  .navbar-logo {
    max-width: 140px;
  }
  .navbar-logo:hover {
    cursor: pointer;
  }
  .navbar-user-icon-item {
    display: inline-block;
  }
  @media (max-width: 1024px) {
    .navbar-brand {
      margin-left: 0;
    }
  }
  @media (max-width: 414px) {
    .navbar-user-icon-item {
      display: none;
    }
  }
  @media (max-width: 320px) {
    .navbar-logo {
      max-width: 110px;
    }
  }
  @media (max-width: 550px) {
    .navbar-nav .right-actions {
      flex-direction: column;
      align-items: flex-end;
    }
  }
`;

const StyledNavbarContainer = styled(Container)`
  max-width: 100%;
`;

const ButtonSidebar = styled.button`
  color: ${(props) => props?.theme?.gray};
  border: 0;
  background-color: transparent;
  line-height: 1;
  margin-left: -5px;
  padding: 5px 10px;
  &.hover {
    color: ${(props) => props?.theme?.darkPurple};
  }
  @media (min-width: 768px) {
    width: 50px;
    margin-left: 0;
  }
`;

const Navigation = (props) => {
  const { show, handleLogoInteraction } = useOverlay();

  return (
    <>
      <StyledNavbar fixed="top" id="navbar">
        <StyledNavbarContainer>
          {props.isLogged && props.withSidebar && (
            <ButtonSidebar
              type="button"
              className="btn-sidebar"
              data-testid="btn-sidebar"
              onClick={() => props.toggleLayoutSidebar()}
            >
              <span>
                <i className="fas fa-bars" aria-hidden="true"></i>
              </span>
            </ButtonSidebar>
          )}
          <Navbar.Brand style={{ padding: "0", margin: "0" }}>
            <Link
              to={getUserDefaultRoute(props.userProfile, props.studies)}
              title="Home"
            >
              <img
                className="navbar-logo"
                src={logo}
                alt="Rarify logo"
                onMouseDown={handleLogoInteraction}
                onTouchStart={handleLogoInteraction}
              />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto" />
            {props.isLogged ? (
              <UserActions
                userProfile={props.userProfile}
                logout={props.logout}
                setPreventNavigation={props.setPreventNavigation}
                history={props.history}
                preventNavigation={props.preventNavigation}
                studies={props.studies}
                name={props.accountName || props.accountUserName}
              />
            ) : (
              <LoginButtons {...props} />
            )}
          </Navbar.Collapse>
        </StyledNavbarContainer>
      </StyledNavbar>
      <Overlay show={show} />
    </>
  );
};

const LoginButtons = (props) => {
  const { t } = useTranslation();

  return (
    <Nav className="float-end">
      <Form className="right-actions">
        <Highlighter
          arrowBottom="-180%"
          arrowLeft="-35px"
          arrowTransform="rotate(-50deg)"
        >
          {(isHighlighted) => (
            <PrimaryButton
              className="btn btn-sm btn-primary me-1"
              name="login"
              id="login"
              type="button"
              data-toggle="modal"
              data-target="#login"
              onClick={() =>
                props.setOpenAuthModal(modalType.login, t("appText.login"))
              }
            >
              {t("appText.login")}
            </PrimaryButton>
          )}
        </Highlighter>
      </Form>
    </Nav>
  );
};

const UserActions = (props) => {
  const { t } = useTranslation();

  return (
    <Nav className="me-lg-3">
      <Nav.Item className="navbar-user-icon-item">
        <Nav.Link eventKey="2">
          <UserImage callback={() => {}} id="user-image" className="me-2" />
        </Nav.Link>
      </Nav.Item>

      <Highlighter
        useArrow={false}
        circleLeft="90%"
        circleWidth="45px"
        circleHeight="45px"
      >
        {(isHighlighted) => (
          <NavDropdown
            title={
              <UserName
                userName={props.name}
                defaultValue={t("appText.myAccount")}
              />
            }
            id="collasible-nav-dropdown"
            className="username-dropdown"
          >
            {studiesDropdownOptions(props.userProfile, props.studies)}
            <Highlighter useArrow={false}>
              {(isHighlighted) => (
                <NavDropdown.Item
                  key="logout"
                  onClick={() => props.logout()}
                  style={
                    isHighlighted
                      ? { backgroundColor: "rgba(0, 0, 0, 0.1)" }
                      : {}
                  }
                >
                  {t("appText.logout")}
                </NavDropdown.Item>
              )}
            </Highlighter>
          </NavDropdown>
        )}
      </Highlighter>
    </Nav>
  );
};

const studiesDropdownOptions = (role, userStudies) => {
  return userStudies?.map((study) => {
    return (
      <NavDropdown.Item
        onClick={() => {
          const defaultRoute = getUserDefaultRoute(role);
          history.push(defaultRoute);
        }}
        key={study.studyId}
      >
        {study.code}
      </NavDropdown.Item>
    );
  });
};

const mapDispatchToProps = {
  ...mapDispatchToPropsLogin,
  ...mapDispatchToPropsLayout,
};

const mapStateToProps = (state) => {
  return {
    ...mapStateToPropsLayout(state),
    ...mapStateToPropsLogin(state),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTheme(Navigation)));
